module.exports = __webpack_public_path__ + "static/assets/b95f0636f878f2cfe2a38f527ffb30bd.svg";